/**
 * Action types for SSID scheduler functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_SSID_SCHEDULER = 'GET_SSID_SCHEDULER';
export const GET_SSID_SCHEDULER_SUCCESS = 'GET_SSID_SCHEDULER_SUCCESS';
export const GET_SSID_SCHEDULER_FAIL = 'GET_SSID_SCHEDULER_FAIL';
export const ADD_SSID_SCHEDULE = 'ADD_SSID_SCHEDULE';

export const EDIT_SSID_SCHEDULE = 'EDIT_SSID_SCHEDULE';
export const EDIT_SSID_SCHEDULE_FAIL = 'EDIT_SSID_SCHEDULE_FAIL ';
export const EDIT_SSID_SCHEDULE_SUCCESS = 'EDIT_SSID_SCHEDULE_SUCCESS';
export const SSID_EDIT_SCHEDULE_SUCCESSS_MESSAGE =
	'SSID_SCHEDULE_UPDATED_SUCCESSFULLY';
export const RESET_SSID_SCHEDULE = 'RESET_SSID_SCHEDULE';
export const SSID_DELETE_SCHEDULE_SUCCESSS_MESSAGE =
	'SSID_SCHEDULE_DELETED_SUCCESSFULLY';

export const ADD_SSID_SCHEDULE_REQUEST = 'ADD_SSID_SCHEDULE_REQUEST';
export const ADD_SSID_SCHEDULE_SUCCESS = 'ADD_SSID_SCHEDULE_SUCCESS';
export const ADD_SSID_SCHEDULE_FAIL = 'ADD_SSID_SCHEDULE_FAIL';
export const ADD_SSID_SCHEDULE_SUCCESS_MESSAGE =
	'SSID_SCHEDULE_ADDED_SUCCESSFULLY';
export const RESET_SSID_SCHEDULE_ADD = 'RESET_SSID_SCHEDULE_ADD';
